import { render, staticRenderFns } from "./Nationality.vue?vue&type=template&id=a3292ca4&scoped=true"
import script from "./Nationality.vue?vue&type=script&lang=js"
export * from "./Nationality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3292ca4",
  null
  
)

export default component.exports